import { extractParameterKeys } from "src/components/Puck/config/fields/extensions/typingSuggestions/token/tokenResolver";

export { extractParameterKeys };

const AI_COMMENT_NAMESPACES = ["company", "campaign", "pdf", "calc"];

export const getUnsupportedParameterKeys = (parameterKeys: string[]): string[] =>
    parameterKeys.filter((key) => !AI_COMMENT_NAMESPACES.includes(key.split(".")[0] ?? ""));

export const getTokenNamespaces = (parameterKeys: string[]): string[] => {
    const namespaces = new Set<string>();

    parameterKeys.forEach((key) => {
        const namespace = key.split(".")[0];
        if (namespace && namespace !== "calc") {
            namespaces.add(namespace);
        }
    });

    return [...namespaces];
};

export const hasCalcParameterKeys = (parameterKeys: string[]): boolean => {
    return parameterKeys.some((key) => key.startsWith("calc."));
};
